import { createContext, useContext } from "react";

const GeolocationContext = createContext({});

export const GeolocationProvider = ({ geolocation, children }) => {
  return <GeolocationContext.Provider value={geolocation}>{children}</GeolocationContext.Provider>;
};

const useGeolocation = () => {
  return useContext(GeolocationContext);
};

export default useGeolocation;
